import React, { useEffect, useState } from "react";
import img from "../../assets/images/Dress Code.jpg";
import Skeleton from "@mui/material/Skeleton";
import CloseIcon from "@mui/icons-material/Close";
import Microlink from "@microlink/react";

const LinkPreview = ({
  text,
  setInputs,
  type,
  post,
  previewLink,
  setPreviewLink,
  selectedFeed,

  typeData,

  forcePreview,
}) => {
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hidePreview, setHidePreview] = useState(false);

  const extractURL = (str) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const match = str.match(urlRegex);
    return match ? match[0] : null;
  };

  const extractDomain = (url) => {
    try {
      const domain = new URL(url).hostname.replace("www.", "");
      return domain;
    } catch (error) {
      return url;
    }
  };

  const extractFakeTitle = (url) => {
    try {
      const pathname = new URL(url).pathname.split("/").filter(Boolean);
      if (pathname.length > 0) {
        return pathname[pathname.length - 1].replace(/[-_]/g, " ");
      }
      return "Website Preview";
    } catch {
      return "Website Preview";
    }
  };

  const getThumbnail = (url) => {
    const domain = new URL(url).hostname;
    return `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;
  };

  useEffect(() => {
    if (!text) {
      setPreviewData(null);

      return;
    }

    setLoading(true);
    const url = extractURL(text);

    if (url) {
      const fakeData = {
        title: extractFakeTitle(url),
        description: extractDomain(url),
        image: getThumbnail(url),
        url,
      };

      setTimeout(() => {
        setPreviewData(fakeData);
        setLoading(false);
      }, 1000);
    } else {
      setTimeout(() => {
        setPreviewData({
          title: "Invalid URL",
          description: "",
          image: img,
          url: text,
        });
        setLoading(false);
      }, 1000);
    }
  }, [text]);

  const handleClose = () => {
    setPreviewData(null);
    setPreviewLink(false);
  };

  if (loading && selectedFeed?.is_link_preview) {
    return (
      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: 5,
          padding: 10,
          display: "flex",
          alignItems: "center",
          gap: 10,
          maxWidth: 600,
        }}
      >
        <Skeleton variant="rectangular" width={100} height={70} />
        <div style={{ flex: 1 }}>
          <Skeleton width="60%" height={20} />
          <Skeleton width="40%" height={14} />
        </div>
      </div>
    );
  }

  if (!previewData) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        maxWidth: 600,
        background: "#fff",
        position: "relative",
      }}
    >
      {/* Raw Link on Top */}
      <a
        href={previewData.url}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: "none",
          color: "#000",
          fontSize: 16,
          fontWeight: 500,
        }}
      >
        {/* {previewData.url} */}
      </a>

      {/* Preview Box */}
      {(selectedFeed?.is_link_preview ||
        typeData === "ADD" ||
        forcePreview) && (
        <div
          style={{
            display: "flex",
            gap: "12px",
            border: "1px solid #ccc",
            borderRadius: 8,
            padding: 10,
            position: "relative",
            backgroundColor: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
          className="post-link-preview"
        >
          <Microlink
            url={text}
            size="normal"
            media="image"
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "100px",
              objectFit: "cover",
            }}
          />
          {type === "icon_show" ? (
            <CloseIcon
              onClick={handleClose}
              style={{
                position: "absolute",
                top: -6,
                right: -6,
                cursor: "pointer",
                fontSize: 18,
                color: "white",
                backgroundColor: "gray",
                borderRadius: "50%",
              }}
            />
          ) : null}
        </div>
      )}
    </div>
  );
};

export default LinkPreview;
